import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PartnerCinema, PartnerCinemas } from './partner-cinema.interface';
import { PartnerCinemaService } from './partner-cinema.service';
import { Filters } from '@/core/store/filter.interface';
const service = new PartnerCinemaService();

export type PARTNER_CINEMA_INCLUDES = 'cinema' | 'user' | 'watchStatus' | 'partner';
export interface PartnerCinemaState {
   partnerCinemas: PartnerCinemas;
}

const PartnerCinemaStore: Module<PartnerCinemaState, StoreState> = {
   namespaced: true,
   state: {
      partnerCinemas: {
         series: [],
         movies: [],
      },
   },
   getters: {},
   mutations: {},
   actions: {
      async getAll(context, filters: Filters) {
         const user = this.state.user?.user;
         if (!user?.id || !user?.partner_id) return;

         const partnerCinemas = (await service.getAll(user.id, user.partner_id, filters)) || [];
         return partnerCinemas;
      },
      async get(_context, partnerCinemaId: number) {
         const partnerCinema = await service.get(partnerCinemaId);
         return partnerCinema;
      },
      async post(_context, partnerCinema: PartnerCinema) {
         const response = await service.post(partnerCinema);
         return response;
      },
      async put(
         _context,
         { id, watch_status_id, watched_season_episodes }: { id: number; watch_status_id: number; watched_season_episodes: string },
      ) {
         const response = await service.put(id, watch_status_id, watched_season_episodes);
         return response;
      },
      async delete(_context, id: number) {
         await service.delete(id);
      },
      // get cinema by user id + partner id + cinema id
      async getByIds(
         context,
         {
            user_id,
            cinema_id,
            partner_id,
            type,
         }: {
            user_id: number;
            cinema_id: number;
            partner_id: number;
            type: 'movie' | 'serie';
         },
      ) {
         return await service.getByIds(user_id, partner_id, cinema_id, type);
      },
   },
};

export default PartnerCinemaStore;
